// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c6bcbedfc8ca59029fca","655":"6053ea7235b014acd7ed"}[chunkId] + ".js";
};